import React, { createContext, useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import _get from 'lodash/get.js';

export const NavigationContext = createContext({});

const NavigationContextProvider = ({children}) => {

    const navigate = useNavigate();
    const getNavigateToActions = () => {
        return {
            'navigateToInspirationAndGallery': () => { navigate('../inspiration')},
            'navigateToStyleSelector': ()=> { navigate('../style')},
            'navigateToPersonal': ()=> { navigate('../personal')},
		    'navigateToPersonalFilm': ()=> { navigate('../personal/film')},
		    'navigateToPersonalGallery': () => { navigate('../personal/gallery')},
            'navigateToBenefits': ()=> { navigate('../benefits')},
        }
    };

    const location = useLocation();
    const [queryStringValues, setQueryStringValues] = useState({});
    const [navigateToActions, setNavigateToActions] = useState(getNavigateToActions(navigate));

    return (
        <NavigationContext.Provider value={{
            location,
            navigate,
            navigateToActions,
            useParams,
            setNavigateToActions,
            queryStringValues, 
            setQueryStringValues
        }}>
            {children}
        </NavigationContext.Provider>
    );
};

export default NavigationContextProvider;